import { Link } from 'react-router-dom';

interface PageCTAProps {
  title?: string;
  description?: string;
  primaryText?: string;
  primaryLink?: string;
  secondaryText?: string;
  secondaryLink?: string;
  showSecondary?: boolean;
  bgGradient?: string;
}

export default function PageCTA({
  title = "Ready to Know Your App's Real Potential?",
  description = "Get clarity, direction, and an intelligence-backed roadmap.",
  primaryText = "Start Evaluation",
  primaryLink = "/pricing",
  secondaryText = "Download Sample Report",
  secondaryLink = "/sample-report",
  showSecondary = true,
  bgGradient = "from-teal-600 to-blue-600"
}: PageCTAProps) {
  return (
    <section className={`py-20 bg-gradient-to-br ${bgGradient}`}>
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          {title}
        </h2>
        <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
          {description}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to={primaryLink}
            className="inline-block bg-white text-teal-600 px-10 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            {primaryText}
          </Link>
          {showSecondary && (
            <Link
              to={secondaryLink}
              className="inline-block bg-white/10 backdrop-blur-sm text-white border-2 border-white px-10 py-4 rounded-full font-semibold text-lg hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              {secondaryText}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
